// The default search criteria for a visitor with no saved preferences. Shared between
// the client's wish defaults and the server's city page query so the worker list the
// server renders is the same list the client's first search returns - otherwise the
// cards swap identity in front of the user once the client query lands.
export const DEFAULT_SEARCH_DAYS = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday'];

// Page size for a signed-out visitor (a promo card is added client-side to round it
// out). The server renders for signed-out visitors by definition, so it uses the same
// size - a smaller server page would leave a gap the client fills in later.
export const DEFAULT_SEARCH_PAGE_SIZE = 19;

export const localeFromTranslations = (translations) => translations.substr(0, translations.indexOf('_'));
